import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/rootReducer";
import useApi from "../../../api";
import { toast } from "react-toastify";
import { useDeleteConfirmation } from "../../common";
import { setTaxClass } from "../../../redux/taxClassSlice";
import TaxClassTable from "./TaxClassTable";
import TaxClassForm from "./TaxClassForm";

function TaxClass() {
  const api = useApi()
  const dispatch = useDispatch()
  
  const taxClass = useSelector((state:RootState)=>state.taxClass.results)

  const [formData, setFormData] = useState<any>({})
  const [taxClassId, setTaxClassId] = useState<number>()

  const [edit, setEdit] = useState<boolean>(false)
  const [errorData, setErrorData] = useState<any>({})

  const [isOpenTaxClass, setIsOpenTaxClass] = useState<boolean>(false)
  const [isOpenDetailView, setIsOpenDetailView] = useState<boolean>(false)
  
  const {handleDelete} = useDeleteConfirmation()
  
  const getTaxClass = () => {
    api.getTaxClassList().then((response:any)=>{
      dispatch(setTaxClass(response.results))
    }).catch((error)=>toast.error("Error fetching tax class"))
  }

  useEffect(()=>{
      getTaxClass()
  }, [dispatch])



  const handleDetailView = (id:number) => {
    setTaxClassId(id)
    setIsOpenDetailView(true)
  }

  const handleEdit = (e:any, id:number) => {
    e.preventDefault()
    setEdit(true)
    setIsOpenTaxClass(true)
    api.getTaxClassById(id).then((response:any)=>setFormData(response)).catch((error)=>toast.error("Error fetching tax class ."))
  }

  const onSubmit = (e:any, id?:number) => {
    e.preventDefault()
    if (!edit) { 
      api.createTaxClass(formData).then((response:any)=>{
        toast.success("Tax class created")
        setIsOpenTaxClass(false)
        getTaxClass()
        setFormData({tax_rates:[{}]})
      }, (error)=>setErrorData(error.response.data))
    } else {
      api.updateTaxClass(id, formData).then((response:any)=>{
        toast.success('Successfully updated tax class.')
        setIsOpenTaxClass(false)
        getTaxClass()
        setFormData({tax_rates:[{}]})
      }, (error)=>setErrorData(error.response.data))
    }
  }
  
  return (
    <>
      <div>
        <h3>Tax Class</h3>
        <button 
          className="my-2 float-right bg-primary-400 py-2 px-5 w-full md:w-[200px] text-white rounded-md hover:bg-primary-500 transition-all duration-150 ease-linear"
          onClick={()=>{
            setIsOpenTaxClass(true)
            setFormData({tax_rates:[{is_active: true}]})
          }}
        >
            Add Tax Class
        </button>
      

          <div className="w-full overflow-x-auto">
            <TaxClassTable data={taxClass}/>
          </div>

          
          {isOpenTaxClass && (
            <TaxClassForm 
              isOpen={isOpenTaxClass}
              onClose={()=>setIsOpenTaxClass(false)}
            />
          )}
      </div>
    </>
  );
}

export default TaxClass;
